import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PiggyBank, ShieldCheck, HeartPulse, Sunrise } from 'lucide-react';
const benefits = [{
  title: 'Ahorro Inteligente',
  description: 'Tu dinero crece con estrategia, no con suerte.',
  icon: PiggyBank
}, {
  title: 'Protección Familiar',
  description: 'Si algo te pasa, tu familia no queda desamparada.',
  icon: ShieldCheck
}, {
  title: 'Beneficios en Vida',
  description: 'Acceso a beneficios mientras estás sano y activo.',
  icon: HeartPulse
}, {
  title: 'Retiro Independiente',
  description: 'Construye un retiro digno, sin depender de nadie.',
  icon: Sunrise
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function SolutionSection() {
  return <section className="bg-magi-cream py-24 md:py-32" data-id="element-86">
      <div className="container mx-auto px-6 md:px-12" data-id="element-87">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-88">
          {/* Left side: Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full lg:w-1/2" data-id="element-89">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-90">
              <img src="https://images.unsplash.com/photo-1609220136736-443140cffec6?w=1920&q=80" alt="Familia hispana abrazada y feliz" className="object-cover w-full h-full" data-id="element-91" />
              <div className="absolute inset-0 bg-magi-brown/10 mix-blend-multiply" data-id="element-92" />
            </div>
          </motion.div>

          {/* Right side: Content */}
          <div className="w-full lg:w-1/2" data-id="element-93">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-gray-900 mb-12 leading-tight" data-id="element-94">
              El banco no te da un plan.{' '}
              <span className="text-magi-brown" data-id="element-95">Este programa sí.</span>
            </motion.h2>

            <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-100px'
          }} className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-96">
              {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 rounded-xl shadow-sm border border-magi-beige/50 hover:shadow-md transition-shadow duration-300" data-id="element-97">
                  <div className="w-12 h-12 bg-magi-beige/30 rounded-full flex items-center justify-center mb-4 text-magi-navy" data-id="element-98">
                    <benefit.icon size={24} strokeWidth={2} data-id="element-99" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-100">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 font-light leading-relaxed" data-id="element-101">
                    {benefit.description}
                  </p>
                </motion.div>)}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}